import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, isRef as _isRef, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, Suspense as _Suspense, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d202de9e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "associated-productlib" }
const _hoisted_2 = { class: "flex-ter" }
const _hoisted_3 = { class: "bind-btn rel" }
const _hoisted_4 = { class: "bind-tip-text flex-center" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { style: {"width":"200px"} }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "iconfont icon-wenhao1",
  style: {"font-size":"14px","cursor":"pointer"}
}, null, -1))
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" - ")
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" - ")
const _hoisted_14 = { key: 0 }
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" - ")
const _hoisted_16 = { style: {"cursor":"pointer"} }
const _hoisted_17 = { style: {"width":"200px"} }
const _hoisted_18 = { class: "line--3" }
const _hoisted_19 = {
  key: 0,
  class: "flex-center"
}
const _hoisted_20 = { style: {"margin-right":"6px"} }
const _hoisted_21 = { class: "line--3" }
const _hoisted_22 = { style: {"max-width":"300px"} }
const _hoisted_23 = { style: {"max-width":"200px","font-size":"14px"} }
const _hoisted_24 = { class: "line--3" }
const _hoisted_25 = { style: {"max-width":"300px"} }
const _hoisted_26 = { style: {"max-width":"200px","font-size":"14px"} }
const _hoisted_27 = { class: "flex-center" }

import { t } from '@/plugins/i18n'
import { ref, Ref, nextTick, onMounted, computed } from 'vue'
import { getWarehouseCode, isMultiStore, useRtfix, useSite } from '@/store'
import STable from '@/components/Table/index.vue'
import ShoppingPreview from '@/components/common/ShoppingPreview.vue'
import SSearch from './Search.vue'
import SyncBtn from '../components/SyncBtn.vue'
import AuthorizedBtn from '../components/AuthorizedBtn.vue'
import AdtOrder from '@/components/additional/AdtOrder.vue'
import Guide from '@/components/guide/index.vue'
import memberEventBox from '@/components/common/MemberEventBox.vue'
import useTabData from '@/util/useTabData'
import { editableTabs, associatedColumns, associatedChildColumns, tableConfig, childConfig, childApiConfig, shopProductBindStatusSnum } from './data'
import useFilter from './useFilter'
import { Edit, Select, QuestionFilled, WarningFilled } from '@element-plus/icons-vue'
import { searchShopProduct, listShopProductSku, updateCustomerProductNo, batchDeleteProduct, editAddition, syncGoods, thirdShopEditAdditionListApi } from '@/apis/associated'
import { ElMessage, ElMessageBox } from 'element-plus'
import { setNoEmptyForm } from '@/util/common'
import { useRouter, useRoute } from 'vue-router'
import { useStore } from 'vuex'
import BatchSearch from '@/components/BatchSearch/index.vue'
import bus from '@/util/useBus'
import AdditionDrawer from '@/components/additional/AdditionDrawer.vue'
import { formatMoneyDirection, showCurrentUnit } from '@/util/useYan'
import useUserConfig, { ENUM_CONFIG_CODE } from '@/util/useUserConfig'
import CopyButton from '@/components/common/CopyButton.vue'
import ChooseSetAdditon from './components/ChooseSetWarehouse.vue'
import { COUNTRY } from '@/global'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const [getConfig, setConfig] = useUserConfig(ENUM_CONFIG_CODE.ASSOCIATED_PRODUCTLIB_TIP)
const route = useRoute()

const childColumns = computed(() => {
  return associatedChildColumns.filter((i) => isMultiStore() || !i.isMultiStore)
})
const columns = computed(() => {
  return associatedColumns.filter(i => (isMultiStore() || !i.isMultiStore)).map((v) => {
    return {
      ...v,
      label: v.prop === 'additionList' && !isMultiStore() ? t('商品附加项') : v.label
    }
  })
})
const STableRef = ref()
const updateLoading = ref(false)
const needChangeSize: any = ref()
const isBackSku: any = ref()
const additionCountryCode = ref('')
const refreshTable = (type?: boolean) => {
  if (type) {
    pageData.value = {
      page: 1,
      limit: 30
    }
  }
  nextTick(() => {
    STableRef.value && STableRef.value.getData()
  })
}
const SChildTableRefs: Ref<any[]> = ref([])
const handleExpandRow = (val: any, flag: boolean) => {
  if (flag) {
    nextTick(() => {
      SChildTableRefs.value[val.shopItemId].getData()
    })
  }
}

const handleExpandAll = (val: any, flag: boolean) => {
  if (flag) {
    for (const el of val) {
      nextTick(() => {
        SChildTableRefs.value[el].getData()
      })
    }
  }
}

const { tabData, bindStatus } = useTabData({ TabName: 'bindStatus' }, () => {
  isBatchSearch.value = false
  refreshTable(true)
})
const { searchForm, filterData } = useFilter(bindStatus)
route.query.thirdItemName && (searchForm.value.thirdItemName = route.query.thirdItemName)
const adtList: any = ref([])
const proxy: any = ref(null)
const rowItem = ref()
const adtType = ref(false) // false 添加单个附加项 true 批量添加附加项
const goodsItem:any = ref({})
let editType = 0 // 1spu编辑附加项 2sku编辑附加项
const singleAdt = (row: any, country?:string) => {
  additionCountryCode.value = country ?? ''
  rowItem.value = row
  editType = 1
  adtList.value = (country === COUNTRY.KR ? row.additionKr?.additionalList : row.additionCn?.additionalList) ?? []
  adtType.value = false
  proxy.value = adtList.value
  needChangeSize.value = ''
  goodsItem.value = {
    ...row,
    noAdditionalFlag: !row.additionCheckType
  }
}

const batchAdtLoading = ref(false)
const setAdditionVisible = ref(false)
const chooseAdditionWarehouse = () => {
  if (!selectionList.value.length) return ElMessage.warning(t('请选择商品'))
  if (isMultiStore()) {
    setAdditionVisible.value = true
    return
  }
  batchAdt(COUNTRY.CN)
}
const batchAdt = (code:string) => {
  additionCountryCode.value = code
  goodsItem.value = {}
  adtList.value = []
  adtType.value = true
  editType = 1
  proxy.value = adtList.value
  needChangeSize.value = ''
}

const handleAdt = (additionalList: any) => {
  if (editType === 2) {
    thirdShopEditAdditionListApi({
      warehouseCode: getWarehouseCode(additionCountryCode.value === 'KR'),
      shopItemSkuIds: [goodsItem.value.shopItemSkuId],
      additionList: additionalList === 1 ? [] : additionalList.map((item: any) => {
        return {
          additionConfigId: item.additionConfigId,
          // TODO additionCode
          additionId: item.additionId,
          additionCode: item.additionCode,
          ingredientsSku: item.ingredientsSku,
          additionName: item.additionName,
          additionNameJp: item.additionNameJp,
          additionExtraName: item.additionExtraName,
          spotCheckFlag: item.spotCheckFlag,
          spotCheckRatio: item.spotCheckRatio
        }
      }),
      needAdditionalFlag: additionalList === 1 ? 0 : 1
    }).then((res: any) => {
      if (res.success) {
        ElMessage.success(t('附加项修改成功'))
        refreshTable()
      }
    })
    return
  }
  adtList.value = additionalList
  const shopItemIds = adtType.value ? selectionList.value : [rowItem.value.shopItemId]
  adtType.value ? batchAdtLoading.value = true : rowItem.value.singleAdtLoading = true
  editAddition({
    shopItemIds,
    warehouseCode: getWarehouseCode(additionCountryCode.value === 'KR'),
    additionList: adtList.value === 1 ? [] : adtList.value.map((e: any) => ({
      additionId: e.additionId,
      // TODO additionCode
      additionCode: e.additionCode,
      additionConfigId: e.additionConfigId,
      ingredientsSku: e.ingredientsSku,
      additionNameJp: e.additionNameJp,
      spotCheckFlag: e.spotCheckFlag,
      spotCheckRatio: e.spotCheckRatio
    })),
    needAdditionalFlag: adtList.value === 1 ? 0 : 1
  }).then((res: any) => {
    if (res.success) {
      ElMessage.success(t('附加项修改成功'))
      refreshTable()
    }
  }).finally(() => {
    adtType.value ? batchAdtLoading.value = false : rowItem.value.singleAdtLoading = false
  })
}

const customerShopAuthStatus = ref(false)

const pageData = ref({
  page: 1,
  limit: 30
})

const closeInput = (row: any) => {
  updateCustomerProductNo({
    shopItemId: row.shopItemId,
    itemRemark: row.itemRemark
  }).then((res: any) => {
    if (res.success) {
      row.isExit = false
      ElMessage.success(t('番号保存成功'))
      refreshTable()
    }
  })
}

const router = useRouter()
const createAssociatedProductlib = (row: any) => {
  if (row.purchaseChannel === 3) {
    router.push(useRtfix('CreateAssociated', {
      query: {
        ...setNoEmptyForm({
          shopItemId: row.shopItemId,
          searchSourceOrderNo: row.searchSourceOrderNo,
          productSku: row.productSku
        })
      }
    }))
  } else if (row.purchaseChannel === 4) {
    router.push(useRtfix('CreateAssociated', {
      query: {
        ...setNoEmptyForm({
          shopItemId: row.shopItemId,
          combinationProductSku: row.combinationProductSku,
          productSku: row.productSku
        })
      }
    }))
  } else {
    router.push(useRtfix('CreateAssociated', {
      query: {
        ...setNoEmptyForm({
          shopItemId: row.shopItemId,
          productCode: row.productCode,
          productSku: row.productSku
        })
      }
    }))
  }
}

const selectionList: any = ref([])
const handleSelection = (val: any[]) => {
  selectionList.value = val.map((e: any) => e.shopItemId)
}

const addSingleDel = async (e: any) => {
  e.delLoading = true
  await delProduct([e.shopItemId])
  e.delLoading = false
}

const batchDelLoading = ref(false)
const addBatchDel = async () => {
  if (!selectionList.value.length) return ElMessage.warning(t('请选择商品'))
  ElMessageBox.confirm(
    ` <div>${t('您将要删除X条商品数据，删除后将无法恢复').replace('X', selectionList.value.length)}</div> `,
    t('提示'),
    {
      dangerouslyUseHTMLString: true,
      confirmButtonText: t('删除'),
      cancelButtonText: t('取消'),
      type: 'warning',
      beforeClose: async (action, instance, done) => {
        if (action === 'confirm') {
          instance.confirmButtonLoading = true
          await delProduct(selectionList.value)
          instance.confirmButtonLoading = false
          done()
        } else {
          done()
        }
      }
    }
  )
}

// const delProductItem = (row: any) => {
//   row.delItemLoading = true
//   deleteShopSku({
//     shopProductSkuId: row.shopProductSkuId
//   }).then((res: any) => {
//     if (res.success) {
//       ElMessage.success(t('删除成功'))
//       handleExpandRow(row, true)
//     }
//   }).catch(() => { row.delItemLoading = false })
// }

const delProduct = (list: any) => {
  batchDeleteProduct({
    shopItemIds: list
  }).then((res: any) => {
    if (res.success) {
      ElMessage.success(t('删除成功'))
      refreshTable()
    }
  })
}

// 更新商品
const store = useStore()
const curshop = computed(() => store.getters.shopInfo)

const updateGoods = (row: any) => {
  if (row.updateLoading) {
    return
  }
  row.updateLoading = true
  syncGoods({
    shopItemId: row.shopItemId
  }).then((res: any) => {
    row.updateLoading = false
    if (res.success) {
      ElMessage.success(t('更新成功'))
      refreshTable()
    }
  })
}

const changeAddition = (e: any, row: any, countryCode: string) => {
  if (e) return
  console.log(e, row)
  editAddition({
    additionList: [],
    shopItemIds: [row.shopItemId],
    needAdditionalFlag: 0,
    warehouseCode: getWarehouseCode(countryCode === COUNTRY.KR)
  }).then((res: any) => {
    if (res.success) {
      ElMessage.success(t('附加项修改成功'))
      refreshTable()
    }
  })
}

const batchSearchParams = ref({})
const isBatchSearch = ref(false) // 是否批量搜索
bus.on('batchSearch', (params: any) => {
  isBatchSearch.value = true
  batchSearchParams.value = {
    ...params,
    bindStatus: bindStatus.value
  }
  refreshTable(true)
})
const search = () => {
  isBatchSearch.value = false
  refreshTable(true)
}

// spu商品信息
let spuGoods = {}
// sku修改附加项
const editAdditionList = (row: any, spu: any) => {
  additionCountryCode.value = row.productCountry
  spuGoods = spu
  editType = 2
  proxy.value = row.additionList || []
  needChangeSize.value = row.productType === 1 ? 1 : 2
  goodsItem.value = {
    ...row,
    noAdditionalFlag: !row.additionCheckType
  }
}
const noAdd = (row: any) => {
  thirdShopEditAdditionListApi({
    shopItemSkuIds: [row.shopItemSkuId],
    additionList: [],
    needAdditionalFlag: 0
  }).then((res: any) => {
    if (res.success) {
      ElMessage.success(t('附加项修改成功'))
      refreshTable()
    }
  })
}

const isShowTip = ref(false)
onMounted(() => {
  getTipStatus()
})
const getTipStatus = async () => {
  isShowTip.value = await getConfig() !== '1'
}
const closeTip = async () => {
  await setConfig('1')
  getTipStatus()
}
getConfig()

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_table_button = _resolveComponent("table-button")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(SSearch, {
      form: _unref(searchForm),
      "onUpdate:form": [
        _cache[2] || (_cache[2] = ($event: any) => (_isRef(searchForm) ? (searchForm).value = $event : null)),
        search
      ]
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, [
          (_unref(curshop).customerShopPlatform !== 7)
            ? (_openBlock(), _createBlock(AuthorizedBtn, {
                key: 0,
                status: customerShopAuthStatus.value,
                "onUpdate:status": _cache[0] || (_cache[0] = ($event: any) => ((customerShopAuthStatus).value = $event))
              }, null, 8, ["status"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_2, [
          _createVNode(memberEventBox, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                type: "primary",
                loading: batchAdtLoading.value,
                onClick: chooseAdditionWarehouse
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('批量编辑附加项')), 1)
                ]),
                _: 1
              }, 8, ["loading"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            loading: batchDelLoading.value,
            onClick: addBatchDel
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('批量删除')), 1)
            ]),
            _: 1
          }, 8, ["loading"]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(memberEventBox, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push(_unref(useRtfix)('CreateAssociated'))))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)('创建关联商品')), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (isShowTip.value)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(["bind-tip", { 'no-bind': !customerShopAuthStatus.value }])
                }, [
                  _createElementVNode("img", {
                    src: "https://static-s.theckb.com/BusinessMarket/Client/associated/close.png",
                    alt: "",
                    class: "bind-close",
                    onClick: closeTip
                  }),
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", {
                      innerHTML: _unref(t)('关联商品可以支持(1对多)的绑定啦！').replace(/\((.*)\)/, `<span>$1</span>`)
                    }, null, 8, _hoisted_5)
                  ])
                ], 2))
              : _createCommentVNode("", true)
          ]),
          (customerShopAuthStatus.value)
            ? (_openBlock(), _createBlock(memberEventBox, {
                key: 0,
                style: { right: '-4px' }
              }, {
                default: _withCtx(() => [
                  _createVNode(SyncBtn, { style: {"margin-left":"6px"} })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["form"]),
    _createVNode(_component_el_tabs, {
      modelValue: _unref(tabData),
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(tabData) ? (tabData).value = $event : null)),
      type: "card",
      class: "demo-tabs"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(editableTabs), (item) => {
          return (_openBlock(), _createBlock(_component_el_tab_pane, {
            key: item.name,
            label: item.title,
            name: item.name
          }, null, 8, ["label", "name"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(STable, {
      ref: (_value, _refs) => {
        _refs['STableRef'] = _value
        STableRef.value = _value
      },
      "page-data": pageData.value,
      "onUpdate:page-data": _cache[5] || (_cache[5] = ($event: any) => ((pageData).value = $event)),
      api: _unref(searchShopProduct),
      columns: _unref(columns),
      filterData: isBatchSearch.value ? batchSearchParams.value : _unref(filterData),
      tableConfig: _unref(tableConfig),
      onExpandRow: handleExpandRow,
      onExpandAll: handleExpandAll,
      onSelectionChange: handleSelection
    }, {
      itemRemarkHead: _withCtx(() => [
        _createElementVNode("div", null, [
          _createTextVNode(_toDisplayString(_unref(t)('客户商品sku')) + " ", 1),
          _createVNode(_component_el_tooltip, {
            effect: "light",
            placement: "top"
          }, {
            content: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(t)('维护此信息，会同步到三方sku中')), 1)
            ]),
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          })
        ])
      ]),
      expand: _withCtx(({ scope }) => [
        _createVNode(STable, {
          class: "productTable",
          ref: (el) => SChildTableRefs.value[scope.row.shopItemId] = el,
          api: _unref(listShopProductSku),
          filterData: { shopItemId: scope.row.shopItemId },
          columns: _unref(childColumns),
          tableConfig: _unref(childConfig),
          apiConfig: _unref(childApiConfig),
          isImmediatelyExec: false,
          showPagination: false
        }, {
          productCountry: _withCtx(({ row }) => [
            (row.productSku)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(row.productCountry === _unref(COUNTRY).KR ? _unref(t)('韩国') : _unref(t)('中国')), 1))
              : (_openBlock(), _createElementBlock("div", _hoisted_9, "-"))
          ]),
          thirdItemAttribute: _withCtx(({ row }) => [
            _createElementVNode("div", null, _toDisplayString(row.thirdItemAttribute.replaceAll(/null| /ig, '') === '' ? row.thirdSkuCode : row.thirdItemAttribute), 1)
          ]),
          thirdSkuCode: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(row.customerShopPlatform === 2 ? (row.skuCode || '-') : row.thirdSkuCode), 1)
          ]),
          bindStatus: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(_unref(shopProductBindStatusSnum)[row.bindStatus]) + " ", 1),
            (row.bindStatus === 2)
              ? (_openBlock(), _createBlock(_component_el_tooltip, {
                  key: 0,
                  placement: "top",
                  effect: "light",
                  content: _unref(t)('因采购链接发生变动，请重新绑定')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, { style: {"cursor":"pointer"} }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(WarningFilled))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["content"]))
              : _createCommentVNode("", true)
          ]),
          productInfo: _withCtx(({ row }) => [
            (row.bindStatus == 1)
              ? (_openBlock(), _createBlock(ShoppingPreview, {
                  key: 0,
                  image: row.productSkuImg || row.productMainImg || '',
                  name: row.productTitle || '',
                  url: row.productCode ? _unref(useRtfix)('goods', { params: { id: row.productCode } }) : ''
                }, null, 8, ["image", "name", "url"]))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _hoisted_10
                ], 64))
          ]),
          productPropertiesName: _withCtx(({ row }) => [
            (row.bindStatus == 1)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  ((row.productType === 1))
                    ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(((row.productPropertiesName || '').split(';') || []).map((e) =>
                (e.replace(/[+-]?\d+\:[+-]?\d+\:/, '') || '').split(':')[1] ?? (e.replace(/[+-]?\d+\:[+-]?\d+\:/, '') || '')).join(',')), 1))
                    : (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(row.productPropertiesName), 1))
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _hoisted_13
                ], 64))
          ]),
          thirdSalePrice: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(_unref(formatMoneyDirection)(row?.thirdSalePrice ?? 0)), 1)
          ]),
          productSellPrice: _withCtx(({ row }) => [
            (row.bindStatus == 1)
              ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(row?.productSellPrice ?? 0) + " " + _toDisplayString(_unref(showCurrentUnit)(row.productCountry === _unref(COUNTRY).KR)), 1))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _hoisted_15
                ], 64))
          ]),
          handler: _withCtx(({ scope: scopeChild }) => [
            _createVNode(_component_table_button, {
              title: scopeChild.row.bindStatus == 1 ? _unref(t)('编辑关联') : _unref(t)('创建关联'),
              type: "text",
              onClick: ($event: any) => (createAssociatedProductlib(scopeChild.row))
            }, null, 8, ["title", "onClick"])
          ]),
          additionList: _withCtx(({ row }) => [
            _withDirectives(_createVNode(_component_el_radio, {
              "model-value": !row.additionCheckType,
              size: "small",
              label: true,
              style: {"margin-right":"0"},
              onChange: ($event: any) => (noAdd(row)),
              disabled: !row.productSku
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('不需要检品')), 1)
              ]),
              _: 2
            }, 1032, ["model-value", "onChange", "disabled"]), [
              [_vShow, !row.additionList?.length]
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_component_el_tooltip, {
                placement: "top",
                effect: "light"
              }, {
                content: _withCtx(() => [
                  _createElementVNode("div", _hoisted_17, _toDisplayString((row.additionList || []).map((v) => v.additionExtra?.additionNameJp).join(',')), 1)
                ]),
                default: _withCtx(() => [
                  _createElementVNode("p", _hoisted_18, _toDisplayString((row.additionList || []).map((v) => v.additionExtra?.additionNameJp).join(',')), 1)
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_el_button, {
                type: "text",
                onClick: ($event: any) => (editAdditionList(row, scope.row)),
                disabled: !row.productSku,
                class: "addition-table-btn"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('修改商品附加项')), 1)
                ]),
                _: 2
              }, 1032, ["onClick", "disabled"])
            ])
          ]),
          _: 2
        }, 1032, ["api", "filterData", "columns", "tableConfig", "apiConfig"])
      ]),
      itemRemark: _withCtx(({ row }) => [
        (!row.isExit)
          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
              _createElementVNode("span", _hoisted_20, _toDisplayString(row.itemRemark), 1),
              _createVNode(_component_el_icon, {
                style: {"cursor":"pointer"},
                onClick: ($event: any) => (row.isExit = true)
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Edit))
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]))
          : (_openBlock(), _createBlock(_component_el_input, {
              key: 1,
              modelValue: row.itemRemark,
              "onUpdate:modelValue": ($event: any) => ((row.itemRemark) = $event),
              maxlength: "100"
            }, {
              suffix: _withCtx(() => [
                _createVNode(_component_el_icon, {
                  style: {"cursor":"pointer"},
                  class: "el-input__icon",
                  onClick: ($event: any) => (closeInput(row))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(Select))
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 2
            }, 1032, ["modelValue", "onUpdate:modelValue"]))
      ]),
      thirdSalePrice: _withCtx(({ row }) => [
        _createTextVNode(_toDisplayString(_unref(formatMoneyDirection)(row?.thirdSalePrice ?? 0)), 1)
      ]),
      additionList: _withCtx(({ row }) => [
        _createVNode(_component_el_tooltip, {
          placement: "top",
          effect: "light"
        }, {
          content: _withCtx(() => [
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("p", null, _toDisplayString((row.additionCn || [])?.additionalList?.map((e) => e.additionExtra?.additionNameJp).join(',')), 1)
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createElementVNode("p", _hoisted_21, _toDisplayString((row.additionCn || [])?.additionalList?.map((e) => e.additionExtra?.additionNameJp).join(',')), 1)
            ])
          ]),
          _: 2
        }, 1024),
        (!row.additionCn?.additionalList || !row.additionCn?.additionalList?.length)
          ? (_openBlock(), _createBlock(_component_el_radio, {
              key: 0,
              label: 1,
              onChange: (e) => { changeAddition(e, row, _unref(COUNTRY).CN) },
              size: "small",
              "model-value": row.additionCn?.additionCheckType === 0 ? 1 : 0
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('不需要检品')), 1)
              ]),
              _: 2
            }, 1032, ["onChange", "model-value"]))
          : _createCommentVNode("", true),
        _createVNode(_component_el_tooltip, {
          placement: "top",
          effect: "light",
          "hide-after": 30
        }, {
          content: _withCtx(() => [
            _createElementVNode("div", _hoisted_23, _toDisplayString(_unref(t)('为您的商品编辑的附加项，会再API下单时直接使用。如需修改请点击此处。')), 1)
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "text",
              onClick: ($event: any) => (singleAdt(row, _unref(COUNTRY).CN))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('修改商品附加项')), 1)
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 2
        }, 1024)
      ]),
      additionList2: _withCtx(({ row }) => [
        _createVNode(_component_el_tooltip, {
          placement: "top",
          effect: "light"
        }, {
          content: _withCtx(() => [
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("p", null, _toDisplayString((row.additionKr || [])?.additionalList?.map((e) => e.additionExtra?.additionNameJp).join(',')), 1)
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createElementVNode("p", _hoisted_24, _toDisplayString((row.additionKr || [])?.additionalList?.map((e) => e.additionExtra?.additionNameJp).join(',')), 1)
            ])
          ]),
          _: 2
        }, 1024),
        (!row.additionKr?.additionalList || !row.additionKr?.additionalList?.length)
          ? (_openBlock(), _createBlock(_component_el_radio, {
              key: 0,
              label: 1,
              onChange: (e) => { changeAddition(e, row, _unref(COUNTRY).KR) },
              size: "small",
              "model-value": row.additionKr?.additionCheckType ? 0 : 1
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('不需要检品')), 1)
              ]),
              _: 2
            }, 1032, ["onChange", "model-value"]))
          : _createCommentVNode("", true),
        _createVNode(_component_el_tooltip, {
          placement: "top",
          effect: "light",
          "hide-after": 30
        }, {
          content: _withCtx(() => [
            _createElementVNode("div", _hoisted_26, _toDisplayString(_unref(t)('为您的商品编辑的附加项，会再API下单时直接使用。如需修改请点击此处。')), 1)
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "text",
              onClick: ($event: any) => (singleAdt(row, _unref(COUNTRY).KR))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('修改商品附加项')), 1)
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 2
        }, 1024)
      ]),
      shopProductInfo: _withCtx(({ row }) => [
        _createElementVNode("div", _hoisted_27, [
          _createVNode(ShoppingPreview, {
            image: row?.thirdItemImage,
            name: row?.thirdItemName
          }, null, 8, ["image", "name"]),
          _createVNode(CopyButton, {
            text: row.thirdItemName
          }, null, 8, ["text"])
        ])
      ]),
      handler: _withCtx(({ scope }) => [
        _createElementVNode("div", {
          class: _normalizeClass(["flex-bwn-wrap", _unref(useSite)()]),
          style: {"padding":"4px 0","width":"100%"}
        }, [
          (_unref(curshop).customerShopPlatform !== 7)
            ? (_openBlock(), _createBlock(memberEventBox, {
                key: 0,
                icon: "member_coin",
                "listen-variable": scope.row
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_table_button, {
                    title: !scope.row.updateLoading ? _unref(t)('商品更新') : _unref(t)('更新中'),
                    type: "text",
                    onClick: ($event: any) => (updateGoods(scope.row))
                  }, null, 8, ["title", "onClick"])
                ]),
                _: 2
              }, 1032, ["listen-variable"]))
            : _createCommentVNode("", true),
          _createVNode(memberEventBox, {
            icon: "member_coin",
            "listen-variable": scope.row
          }, {
            default: _withCtx(() => [
              _createVNode(_component_table_button, {
                type: "text",
                title: scope.row.bindingCount ? _unref(t)('编辑关联') : _unref(t)('创建关联'),
                onClick: ($event: any) => (_ctx.$router.push(_unref(useRtfix)('CreateAssociated', { query: { ..._unref(setNoEmptyForm)({ shopItemId: scope.row.shopItemId }) } })))
              }, null, 8, ["title", "onClick"])
            ]),
            _: 2
          }, 1032, ["listen-variable"]),
          _createVNode(_component_el_popconfirm, {
            "popper-class": "pay-pop",
            title: _unref(t)('是否确认删除'),
            onConfirm: ($event: any) => (addSingleDel(scope.row))
          }, {
            reference: _withCtx(() => [
              _createVNode(_component_table_button, {
                title: _unref(t)('删除'),
                loading: scope.row.delLoading,
                onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
              }, null, 8, ["title", "loading"])
            ]),
            _: 2
          }, 1032, ["title", "onConfirm"])
        ], 2)
      ]),
      _: 1
    }, 8, ["page-data", "api", "columns", "filterData", "tableConfig"]),
    (_openBlock(), _createBlock(_Suspense, null, {
      default: _withCtx(() => [
        (proxy.value)
          ? (_openBlock(), _createBlock(AdditionDrawer, {
              key: 0,
              list: proxy.value,
              "onUpdate:list": _cache[6] || (_cache[6] = ($event: any) => ((proxy).value = $event)),
              onCommit: handleAdt,
              proxy: goodsItem.value,
              needChangeSize: needChangeSize.value,
              isBackSku: true,
              type: "AdtOrder",
              hiddenWashSku: true,
              countryCode: additionCountryCode.value
            }, null, 8, ["list", "proxy", "needChangeSize", "countryCode"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })),
    _createVNode(Guide, { name: "cssociated-product" }),
    _createVNode(BatchSearch),
    _createVNode(ChooseSetAdditon, {
      visible: setAdditionVisible.value,
      "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => ((setAdditionVisible).value = $event)),
      onSuccess: batchAdt
    }, null, 8, ["visible"])
  ]))
}
}

})